// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-group-item:hover {
  background-color: #152046;
  color: #fff;
}

.tabcontent .title {
  font-size: 3rem;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .tabcontent .title {
    font-size: 3rem;
    font-weight: 600;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/home/styles/newdetail.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEI;EACI,eAAA;EACA,gBAAA;AACR;;AAGA;EAEQ;IACI,eAAA;IACA,gBAAA;EADV;AACF","sourcesContent":[".list-group-item:hover {\n    background-color: #152046; \n    color: #fff;\n}\n.tabcontent {\n    .title{\n        font-size: 3rem;\n        font-weight: 600;\n    }\n}\n\n@media (max-width:1200px) {\n    .tabcontent {\n        .title{\n            font-size: 3rem;\n            font-weight: 600;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
